export const activityDetails = [
	{
	  "apmc_name": "Ahmedabad Krishi Mandi",
	  "email": "info@ahmedabadapmc.com",
	  "phone_number": "+91 9876543210",
	  "commodities": ["Groundnut", "Cotton", "Wheat"],
	  "address": "Sector 12, Krishi Mandi, Ahmedabad",
	  "pincode": "380001",
	  "state": "Gujarat",
	  "district": "Ahmedabad",
	  "city_village": "Ahmedabad",
	  "post": "Ahmedabad GPO",
	  "license_no": "GJ12345678",
	  "documents": [
		"https://example.com/docs/license_ahmedabad.pdf",
		"https://example.com/docs/registration_ahmedabad.pdf"
	  ],
	  "actions": null
	},
	{
	  "apmc_name": "Rajkot Agricultural Market",
	  "email": "support@rajkotapmc.com",
	  "phone_number": "+91 9123456789",
	  "commodities": ["Peanuts", "Cumin", "Garlic"],
	  "address": "Market Yard, Rajkot",
	  "pincode": "360001",
	  "state": "Gujarat",
	  "district": "Rajkot",
	  "city_village": "Rajkot",
	  "post": "Rajkot Market",
	  "license_no": "GJ98765432",
	  "documents": [
		"https://example.com/docs/business-cert_rajkot.pdf"
	  ],
	  "actions": null
	},
	{
	  "apmc_name": "Surat Fresh Market",
	  "email": "contact@suratapmc.com",
	  "phone_number": "+91 9988776655",
	  "commodities": ["Sugarcane", "Banana", "Turmeric"],
	  "address": "Surat Agricultural Hub, Surat",
	  "pincode": "395001",
	  "state": "Gujarat",
	  "district": "Surat",
	  "city_village": "Surat",
	  "post": "Surat Main Post",
	  "license_no": "GJ55667788",
	  "documents": [
		"https://example.com/docs/agreement_surat.pdf"
	  ],
	  "actions": null
	},
	{
	  "apmc_name": "Bhavnagar Grain Market",
	  "email": "help@bhavnagarapmc.com",
	  "phone_number": "+91 9876123456",
	  "commodities": ["Wheat", "Bajra", "Jowar"],
	  "address": "APMC Yard, Bhavnagar",
	  "pincode": "364001",
	  "state": "Gujarat",
	  "district": "Bhavnagar",
	  "city_village": "Bhavnagar",
	  "post": "Bhavnagar West",
	  "license_no": "GJ11223344",
	  "documents": [
		"https://example.com/docs/license_bhavnagar.pdf"
	  ],
	  "actions": null
	}
  ]
  